/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    playing: PropTypes.bool,
    className: PropTypes.string,
};

const PlayIcon = ({ color = '#FFF', playing = false, className = null }) => (
    <svg
        width="50px"
        height="50px"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        {playing ? (
            <>
                <path
                    fill={color}
                    d="M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0ZM25,46c-11.58,0-21-9.42-21-21S13.42,4,25,4s21,9.42,21,21-9.42,21-21,21Z"
                />
                <path
                    fill={color}
                    d="M34.05,9.23l-14.98,2.08c-.46.06-.8.45-.8.91v18.15h-2.96c-2.56,0-4.64,1.74-4.64,3.88s2.08,3.88,4.64,3.88,4.64-1.74,4.64-3.88v-15.54c0-.3.22-.56.52-.6l12.24-1.7c.36-.05.69.23.69.6v10.78h-2.96c-2.56,0-4.64,1.74-4.64,3.88s2.08,3.88,4.64,3.88,4.64-1.74,4.64-3.88V10.15c0-.56-.49-.99-1.05-.91Z"
                />
            </>
        ) : (
            <>
                <path
                    fill={color}
                    d="M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0ZM4,25C4,13.42,13.42,4,25,4c5.13,0,9.84,1.85,13.49,4.92l-29.57,29.57c-3.07-3.65-4.92-8.36-4.92-13.49ZM25,46c-5.13,0-9.84-1.85-13.49-4.92l29.57-29.57c3.07,3.65,4.92,8.36,4.92,13.49,0,11.58-9.42,21-21,21Z"
                />
                <path
                    fill={color}
                    d="M15.38,30.37h-.07c-2.56,0-4.64,1.74-4.64,3.88,0,.26.03.51.09.75l4.62-4.62Z"
                />
                <path
                    fill={color}
                    d="M19.95,18.71c0-.3.22-.56.52-.6l8.32-1.15,6.3-6.3v-.51c0-.56-.49-.99-1.05-.91l-14.98,2.08c-.46.06-.8.45-.8.91v15.26s1.68-1.69,1.68-1.69v-7.09Z"
                />
                <path fill={color} d="M19.95,34.29l-3.77,3.77c2.13-.34,3.74-1.89,3.77-3.77Z" />
                <path
                    fill={color}
                    d="M33.41,27.8h-2.96c-2.56,0-4.64,1.74-4.64,3.88s2.08,3.88,4.64,3.88,4.64-1.74,4.64-3.88v-12.53l-1.69,1.69v6.96Z"
                />
            </>
        )}
    </svg>
);

PlayIcon.propTypes = propTypes;

export default PlayIcon;
